// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__wCcl_","col":"styles_col__6GTzK"};